import {Component, OnInit} from '@angular/core';
import {Apollo} from "apollo-angular";
import {getAllCategorias} from "../../../graphql/graphql.queris";
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {RouterLink} from "@angular/router";
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-especialidades-list',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    RouterLink,
    NgOptimizedImage
  ],
  templateUrl: './especialidades-list.component.html',
  styleUrl: '../../servicios-person/services-list/services-list.component.css'
})
export class EspecialidadesListComponent implements OnInit{

  especialidades: any[] = [];
  especialidadesVisibles: any[] = [];
  especialidadesPorPagina = 50;
  paginaActual = 1;
  loading = true;
  error: any;
  serverImgenUrl = environment.imgUrl;



  constructor(
    private apollo: Apollo
  ) {
  }

  ngOnInit():void {
    this.apollo
      .watchQuery({
        query: getAllCategorias
      })
      .valueChanges.subscribe((result: any) => {
      this.especialidades = result?.data?.getAllDataWebPublic;
      this.especialidades = [...this.especialidades].sort((n1, n2) => {
        if (n1.especialidad > n2.especialidad) {
          return 1;
        }
        if (n1.especialidad < n2.especialidad) {
          return -1;
        }
        return 0;
      });
      this.cargarMas();
      this.loading = result.loading;
      this.error = result.error;
    })
  }


  cargarMas(): void {
    const inicio = (this.paginaActual - 1) * this.especialidadesPorPagina;
    const fin = this.paginaActual * this.especialidadesPorPagina;
    this.especialidadesVisibles = this.especialidadesVisibles.concat(this.especialidades.slice(inicio, fin));
    this.paginaActual++;
  }

}
